import { Routes } from '@angular/router';

import HistoryComponent from './history.component';

export default <Routes>[
  {
    path: '',
    loadComponent: async () => import('./history.component'),
    data: HistoryComponent
  }
];
